import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=cbc84b9e&scoped=true"
import script from "./TicketsView.vue?vue&type=script&lang=js"
export * from "./TicketsView.vue?vue&type=script&lang=js"
import style0 from "./TicketsView.vue?vue&type=style&index=0&id=cbc84b9e&prod&lang=scss&scoped=true"
import style1 from "./TicketsView.vue?vue&type=style&index=1&id=cbc84b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc84b9e",
  null
  
)

export default component.exports